import { PayoutBank as PayoutBankDto } from 'legacy/events/types';

function getBankLabel(bank: PayoutBankDto) {
  return bank ? `Account ending with ${bank.last4}` : 'Using default account';
}

export default getBankLabel;
